package com.kanati.shared.commerce

import kotlinx.serialization.Serializable

@Serializable
data class SetInventoryRequest(
    val districtId: String,
    val schoolId: String = "",
    val productId: String,
    val quantityOnHand: Int,
    val reason: String? = null,
)

@Serializable
data class AdjustInventoryRequest(
    val districtId: String,
    val schoolId: String = "",
    val productId: String,
    val delta: Int,
    val reason: String,
)

@Serializable
data class InventoryResponse(
    val districtId: String,
    val schoolId: String = "",
    val productId: String,
    val productName: String,
    val quantityOnHand: Int,
    val updatedAt: String?,
)
